export function addUtmParameters(baseUrl) {
    const utmParameters = ["utm_", "externalId", "fbclid", "gclid", "sfmc_"];
    const requestParams = new URLSearchParams(window.location.search);
    
    const url = new URL(baseUrl);
    const newParams = new URLSearchParams(url.search);

    requestParams.forEach((value, key) => {
        if (utmParameters.some(prefix => key.startsWith(prefix))) {
            newParams.set(key, value);
        }
    });

    url.search = newParams.toString();
    return url.toString();
}
